import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/master/sampling-monitor-products'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        findAllMonitorProductByMonitorType(context, { monitorTypeId, searchQuery, config }) {
            const criteria = {
                select: ['**'],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }],
                where: [
                    { name: "refSamplingMonitorType.id", type: "UUID", operator: '=', value: monitorTypeId },
                ],
            }
            if (searchQuery) {
                criteria.where.push({ openBucket: true, name: "name", type: 'String', operator: 'like', value: searchQuery })
                criteria.where.push({ closeBucket: true, logic: "OR", name: "code", type: 'String', operator: 'like', value: searchQuery })
            }
            return context.dispatch('search', { criteria, config })
                .then(page => {
                    const list = page.data
                    return list
                });
        },
    },
    mutations: {
        ...base.mutations
    },
}
